export default "__VITE_ASSET__3d8b0493__"